<template>
  <v-list>
    <v-list-item
      v-for="(item, index) in themeDropdownOptions"
      :key="index"
      :active="$themeStore.theme === item.value"
      class="d-flex align-center"
      color="secondary"
      @click="handleClick(item.value)">
      <template v-slot:prepend>
        <MoonIcon v-if="item.title === 'Hell'" />
        <SunIcon v-else />
      </template>
      <v-list-item-title class="text-subtitle-1 font-weight-regular ml-3">
        {{ item.title }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { LightTheme } from '@/theme/LightTheme.ts';
import { DarkTheme } from '@/theme/DarkTheme.ts';
import { MoonIcon, SunIcon } from 'vue-tabler-icons';
import { useThemeStore } from '@/stores/theme';

const $themeStore = useThemeStore();

const themeDropdownOptions = ref([
  { title: 'Hell', value: LightTheme.name },
  { title: 'Dunkel', value: DarkTheme.name }
]);

function handleClick(theme: string) {
  $themeStore.setTheme(theme);
}

defineExpose({ $themeStore });
</script>
